import type { AdminViewDefinition } from "../../components/admin-components.js";

export const jobAdminViews: AdminViewDefinition[] = [jobsListView(), jobDetailView()];

function jobsListView(): AdminViewDefinition {
  return {
    id: "jobs-list",
    navId: "jobs",
    title: "Background Jobs",
    description:
      "Inspect failed and recent jobs, retry safe operations, and reconcile unknown external outcomes.",
    actions: [
      {
        label: "Bulk replay selected",
        routeId: "bulk-replay",
        disabled: true,
        disabledReason: "Bulk replay does not have a backend API yet.",
      },
      {
        label: "DLQ summary",
        variant: "soft",
        routeId: "dlq-summary",
        disabled: true,
        disabledReason: "DLQ summary does not have a backend API yet.",
      },
    ],
  };
}

function jobDetailView(): AdminViewDefinition {
  return {
    id: "job-detail",
    navId: "jobs",
    title: "Failed Job Detail",
    description:
      "Review sanitized attempts, idempotency, retry safety, runbook, and worker diagnostics.",
    actions: [
      { label: "Open store", routeId: "store-detail-overview" },
      { label: "Retry job", variant: "primary", routeId: "retry-job" },
      {
        label: "Quarantine",
        variant: "danger",
        routeId: "quarantine-job",
        disabled: true,
        disabledReason: "Job quarantine does not have a backend API yet.",
      },
    ],
    callouts: [
      {
        title: "Retry invariant",
        body: "Retry will create a new immutable attempt. The original failed attempts remain visible.",
        tone: "blue",
      },
    ],
  };
}
